export enum HouseType {
  Maison = "Maison",
  Appartement = "Appartement",
}
